<mat-card><mat-card-title>Sorry, no valid account record can be found for {{ username$ | async }}</mat-card-title>
    <br/>
    <mat-card-content>
        <p>Your attempt to access has been registered.</p>
        <p>If you believe that you should have access please contact the Teaching-Office.</p>
    </mat-card-content>
</mat-card>
